import { render } from "./UserDocumentView.vue?vue&type=template&id=ae0fa836"
import script from "./UserDocumentView.vue?vue&type=script&lang=js"
export * from "./UserDocumentView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__